import { render, staticRenderFns } from "./Dungeon.vue?vue&type=template&id=3be1f39a&scoped=true&"
import script from "./Dungeon.vue?vue&type=script&lang=js&"
export * from "./Dungeon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be1f39a",
  null
  
)

export default component.exports